import { Injectable, OnDestroy } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { AttendanceActions } from "src/app/modules/attendance/store/attendance/attendance.actions";
import { CenterActions } from "src/app/modules/center/store/center.actions";
import { ContractActions } from "src/app/modules/contract/stores/contract/contract.actions";
import { FamilyActions } from "src/app/modules/family/store/family/family.actions";
import { SchoolActions } from "src/app/modules/school/store/school.actions";
import { ServiceConceptTypeActions } from "src/app/modules/service-concept/store/service-concept-type/service-concepts-type.actions";
import { DestroyListItem } from "../models/destroy-list.model";
import { AuthActions } from "src/app/modules/login/store/auth.actions";
import { HolidaysActions } from "src/app/modules/holidays/store/holidays.actions";
import { ExerciseActions } from "src/app/modules/exercise/store/exercise.actions";
import { MonitorActions } from "src/app/modules/monitor/store/monitor.actions";
import { ReportActions } from "src/app/modules/reporting/store/report/report.actions";
import { AttendanceServicesActions } from "src/app/modules/attendance-services/stores/attendance-services.actions";
import { InvoiceTemplateActions } from "src/app/modules/invoice-template/store/invoice-template.actions";
import { PermissionActions } from "src/app/modules/permissions/store/permission.actions";
import { ImportsActions } from "src/app/modules/imports/store/imports.actions";

@Injectable({
  providedIn: 'root'
})
export class ClearStateOnRootChangeGuard implements CanActivate {

  private previousRoot: string;
  private destroyList: DestroyListItem[] = [
    { path: 'login', exceptions: [], destroy: () => this.store.dispatch(new AuthActions.SetDefaultState()) },
    { path: 'maintenance/schools', exceptions: [], destroy: () => this.store.dispatch(new SchoolActions.SetSchoolsDefaultState()) },
    { path: 'maintenance/centers', exceptions: [], destroy: () => this.store.dispatch(new CenterActions.SetCenterDefaults()) },
    { path: 'maintenance/contracts', exceptions: [], destroy: () => this.store.dispatch(new ContractActions.SetContractsDefaultState()) },
    { path: 'maintenance/families', exceptions: [], destroy: () => this.store.dispatch(new FamilyActions.SetFamilyDefaults()) },
    { path: 'maintenance/attendance', exceptions: ["/maintenance/families/family"], destroy: () => this.store.dispatch(new AttendanceActions.SetDefaultState()) },
    { path: 'attendances-cau', exceptions: [], destroy: () => this.store.dispatch(new AttendanceActions.SetDefaultState()) },
    { path: 'attendance', exceptions: [], destroy: () => this.store.dispatch(new AttendanceActions.SetDefaultState()) },
    { path: 'maintenance/service-concept', exceptions: [], destroy: () => this.store.dispatch(new ServiceConceptTypeActions.SetDefaults()) },
    { path: 'maintenance/holidays', exceptions: [], destroy: () => this.store.dispatch(new HolidaysActions.SetHolidaysDefaultState()) },
    { path: 'maintenance/exercises', exceptions: [], destroy: () => this.store.dispatch(new ExerciseActions.SetExerciseDefaultState()) },
    { path: 'monitors', exceptions: [], destroy: () => this.store.dispatch(new MonitorActions.SetDefaultState()) },   
    { path: 'configuration/reporting', exceptions: [], destroy: () => this.store.dispatch(new ReportActions.SetReportDefaultState()) },
    { path: 'monitors/services-per-day', exceptions: [], destroy: () => this.store.dispatch(new AttendanceServicesActions.SetAttendanceServicesDefaultState()) },
    { path: 'maintenance/invoice-templates', exceptions: [], destroy: () => this.store.dispatch(new InvoiceTemplateActions.SetInvoiceTemplatesDefaultState()) },
    { path: 'configuration/menus', exceptions: [], destroy: () => this.store.dispatch(new PermissionActions.SetDefaultState()) },
    { path: 'configuration/reporting', exceptions: [], destroy: () => this.store.dispatch(new ReportActions.SetReportDefaultState()) },
    { path: 'maintenance/imports', exceptions: [], destroy: () => this.store.dispatch(new ImportsActions.SetDefaultState()) },
    { path: 'monitor/login', exceptions: [], destroy: () => {this.store.dispatch(new SchoolActions.SetSchoolsDefaultState()); this.store.dispatch(new MonitorActions.SetDefaultState())} },
  ];

  constructor(
    private store: Store
  ) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentRoot = route.url.map(segment => segment.path).join('/');
    let fullPath = state.url.split('?')[0];
    if(currentRoot === this.previousRoot) return true;
    let destroyItem = this.destroyList.find(item => item.path === this.previousRoot);
    if (destroyItem && !destroyItem.exceptions.includes(fullPath)) { destroyItem.destroy(); }
    this.previousRoot = currentRoot;
    return true;
  }

}
